/**
 * Module-level accumulator for the primer the user most recently clicked on the
 * Computer homepage. Consumed (and cleared) when the query is submitted so the
 * `computer primer query submitted` analytics event can preserve the original
 * primer context and detect whether the prefilled query was edited.
 */
let pending = null;
export function setPendingComputerPrimer(primer) {
    pending = primer;
}
export function consumePendingComputerPrimer() {
    const result = pending;
    pending = null;
    return result;
}
//# sourceMappingURL=pendingComputerPrimer.js.map